import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Card from '../shared/Card.svelte';
import { getAllActiveReminders, getNextReminderTime } from '../../lib/services/reminders';
import { formatDuration } from '../../lib/utils/time';

var root_2 = $.from_html(`<div class="next-up svelte-3joqsa4gpolcr"><span class="next-icon">🔔</span> <span class="next-text">Next reminder in <strong class="svelte-3joqsa4gpolcr"> </strong></span></div>`);

function NextUp($$anchor, $$props) {
	$.push($$props, true);

	let reminders = $.state($.proxy([]));
	let nextTime = $.state(null);

	$.user_effect(() => {
		loadData();

		const interval = setInterval(loadData, 60000);

		return () => clearInterval(interval);
	});

	async function loadData() {
		$.set(reminders, await getAllActiveReminders(), true);
		$.set(nextTime, getNextReminderTime($.get(reminders)), true);
	}

	const timeUntil = $.derived(() => () => {
		if (!$.get(nextTime)) return null;

		const diff = $.get(nextTime) - Date.now();

		if (diff <= 0) return 'now';

		return formatDuration(diff);
	});

	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			var fragment_1 = $.comment();
			var node_1 = $.first_child(fragment_1);

			Card(node_1, {
				padding: 'sm',
				children: ($$anchor, $$slotProps) => {
					var div = root_2();
					var span = $.sibling($.child(div), 2);
					var strong = $.sibling($.child(span));
					var text = $.child(strong, true);

					$.reset(strong);
					$.reset(span);
					$.reset(div);
					$.template_effect(($0) => $.set_text(text, $0), [() => $.get(timeUntil)()]);
					$.append($$anchor, div);
				},
				$$slots: { default: true }
			});

			$.append($$anchor, fragment_1);
		};

		$.if(node, ($$render) => {
			if ($.get(nextTime)) $$render(consequent);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	NextUp = $.hmr(NextUp);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-3joqsa4gpolcr');
		NextUp[$.HMR].update(module.default);
	});
}

export default NextUp;
import "bun-svelte:NextUp.svelte-1o6f2f6zdqarb-style.css";